import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'rtQueryFilter',
  standalone: true,
})
export class QueryFilterPipe implements PipeTransform {
  public transform<T>(items: T[], field: keyof T, query: string): T[] {
    if (!query || !items.length) return items;
    if (typeof items[0][field] !== 'string') return items;
    const _query = query.toLowerCase();
    return items.filter(i => (<string>i[field]).toLowerCase().includes(_query));
  }
}
